<svelte:options customElement="hb-dialog-loader" />

<script lang="ts">
  import pkg from "../../../package.json";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type { Events as DialogEvents } from "../dialog/types/webcomponent.type";
  import type { Component } from "./types/webcomponent.type";
  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-dialog", version: pkg.version });

  let {
    id = "",
    // style,
    title = "loading",
    percentage = 0,
  }: Component = $props();

  let completed: boolean;
  $effect(() => {
    if (typeof percentage === "string") percentage = parseInt(percentage);

    // if (style) {
    //     dialogStyleSetup?.vars
    //   );
    // }
    if (!completed) completed = false;
  });

  function dialogShowEvent(d: DialogEvents["modalShow"]) {
    dispatch("modalShow", d);
  }
</script>

<hb-dialog
  show={percentage ? "yes" : "no"}
  onmodalShow={(d: { detail: DialogEvents["modalShow"] }) =>
    dialogShowEvent(d.detail)}
>
  <span slot="title">
    <slot name="title">{title}</slot>
  </span>
  <div slot="body-content">
    <progress
      class="progress is-primary"
      value={Math.round(percentage)}
      max="100"
      aria-valuenow={Math.round(percentage)}
      aria-valuemin="0"
      aria-valuemax="100"
      title="{Math.round(percentage)}%"
    ></progress>
    <span class="hb-dialog-loader-percent is-block has-text-centered is-size-7"
      >{Math.round(percentage)}%</span
    >
  </div>
  <span slot="modal-footer"></span>
</hb-dialog>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
